<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{ 'crear-solicitud.promover' | translate }}
      </h2>
    </div>
    <div
      class="wrapper__contentComponent--expediente container my-5"
      id="encabezado">
      <app-encabezado-expediente></app-encabezado-expediente>
    </div>
    <div class="col-12">
      <h1 *ngIf="entidadId != Constants.ID_ENTIDAD_SIC" class="text-center h4-tipografia-govco mb-0">
        {{ 'crear-solicitud.crear' | translate }}
      </h1>
      <h1 *ngIf="entidadId == Constants.ID_ENTIDAD_SIC" class="text-center h4-tipografia-govco mb-0">
        {{ 'crear-solicitud.crear-sic' | translate }}
      </h1>
    </div>
  </div>
  <div class="container mt-5">
    <form [formGroup]="solicitudForm">
      <div id="form-solicitud">
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="form-group">
              <div *ngIf="entidadId == Constants.ID_ENTIDAD_SIC" class="row mb-3">

                <div class="col-md-6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="solicitudFormEditable"
                      formControlName="tipoSolicitud"
                      value="1" />

                    <label class="form-check-label" for="solicitudFormEditable">
                      {{ 'crear-solicitud.tipo-solicitud-redactar' | translate }}
                    </label>
                  </div>

                  <div class="form-check mt-1">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="solicitudAnexarDoc"
                      formControlName="tipoSolicitud"
                      value="2" />

                    <label class="form-check-label" for="solicitudAnexarDoc">
                      {{ 'crear-solicitud.tipo-solicitud-anexar' | translate }}
                    </label>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="solicitudForm.get('tipoSolicitud')?.value == Constants.TIPO_SOLICITUD_UNO">
                  <label for="solicitud">{{ 'crear-solicitud.solicitud' | translate }}</label><span class="text-danger"> *</span>

                  <select id="solicitud" formControlName="solicitud" class="form-select">
                    <option value="">
                      {{ 'tramites.seleccione-opcion' | translate }}
                    </option>
                    <option *ngFor="let item of listasSolicitud" [value]="item.Nombre">
                      {{ item.Nombre }}
                    </option>
                  </select>
                </div>
              </div>
              <div *ngIf="entidadId == Constants.ID_ENTIDAD_SIC && solicitudForm.get('tipoSolicitud')?.value == Constants.TIPO_SOLICITUD_UNO ">
              <label for="descripcion"
                >{{ 'crear-solicitud.descripcion' | translate }} </label
              ><span class="text-danger"> *</span>
                <textarea
                  class="form-control"
                  id="descripcion"
                  rows="4"
                  maxlength="{{ maxLengthDescripcion }}"
                  (input)="validateInputLength($event, maxLengthDescripcion)"
                  formControlName="descripcion"
                  placeholder="{{ 'crear-solicitud.ingrese-descripcion' | translate }}"
                  (blur)="transformToUppercase('descripcion')">
                </textarea>
              <div
                *ngIf="
                  solicitudForm.get('descripcion')?.invalid &&
                  (solicitudForm.get('descripcion')?.dirty ||
                    solicitudForm.get('descripcion')?.touched)
                ">
                <span
                  *ngIf="solicitudForm.get('descripcion')?.errors?.['required']"
                  class="text-danger">
                  {{ 'crear-solicitud.descripcion-obligatorio' | translate }}
                </span>
                <span
                  *ngIf="solicitudForm.get('descripcion')?.errors?.['pattern']"
                  class="text-danger">
                  {{ 'crear-solicitud.descripcion-caracteres' | translate }}
                </span>
              </div>
              </div>
              <div *ngIf="entidadId != Constants.ID_ENTIDAD_SIC ">
                <label for="asunto"
                >{{ 'crear-solicitud.asunto' | translate }} </label
                ><span class="text-danger"> *</span>
                <input
                  type="text"
                  class="form-control"
                  id="asunto"
                  maxlength="{{ maxLengthAsunto }}"
                  (input)="validateInputLength($event, maxLengthAsunto)"
                  formControlName="asunto"
                  placeholder="{{
                  'crear-solicitud.ingrese-asunto' | translate
                }}"
                  (blur)="transformToUppercase('asunto')"/>
                <div
                  *ngIf="
                  solicitudForm.get('asunto')?.invalid &&
                  (solicitudForm.get('asunto')?.dirty ||
                    solicitudForm.get('asunto')?.touched)
                ">
                <span
                  *ngIf="solicitudForm.get('asunto')?.errors?.['required']"
                  class="text-danger">
                  {{ 'crear-solicitud.asunto-obligatorio' | translate }}
                </span>
                  <span
                    *ngIf="solicitudForm.get('asunto')?.errors?.['pattern']"
                    class="text-danger">
                  {{ 'crear-solicitud.asunto-caracteres' | translate }}
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="entidadId != Constants.ID_ENTIDAD_SIC">
          <div class="col-md-6">
            <div class="form-group" >
              <label for="nombres"
                >{{ 'crear-solicitud.nombres' | translate }} </label
              ><span class="text-danger"> *</span>
              <input
                type="text"
                class="form-control"
                id="nombres"
                maxlength="{{ maxLengthNombre }}"
                (input)="validateInputLength($event, maxLengthNombre)"
                formControlName="nombres"
                placeholder="{{
                  'crear-solicitud.ingrese-nombres' | translate
                }}"
                (blur)="transformToUppercase('nombres')" />
              <div
                *ngIf="
                  solicitudForm.get('nombres')?.invalid &&
                  (solicitudForm.get('nombres')?.dirty ||
                    solicitudForm.get('nombres')?.touched)
                ">
                <span
                  *ngIf="solicitudForm.get('nombres')?.errors?.['required']"
                  class="text-danger">
                  {{ 'crear-solicitud.nombre-obligatorio' | translate }}
                </span>
                <span
                  *ngIf="solicitudForm.get('nombres')?.errors?.['pattern']"
                  class="text-danger">
                  {{ 'crear-solicitud.nombre-validacion' | translate }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="apellidos"
                >{{ 'crear-solicitud.apellidos' | translate }} </label
              ><span class="text-danger"> *</span>
              <input
                type="text"
                class="form-control"
                id="apellidos"
                maxlength="{{ maxLengthApellidos }}"
                (input)="validateInputLength($event, maxLengthApellidos)"
                formControlName="apellidos"
                placeholder="{{
                  'crear-solicitud.ingrese-apellidos' | translate
                }}"
                (blur)="transformToUppercase('apellidos')" />
              <div
                *ngIf="
                  solicitudForm.get('apellidos')?.invalid &&
                  (solicitudForm.get('apellidos')?.dirty ||
                    solicitudForm.get('apellidos')?.touched)
                ">
                <span
                  *ngIf="solicitudForm.get('apellidos')?.errors?.['required']"
                  class="text-danger"
                  >{{
                    'crear-solicitud.apellidos-obligatorio' | translate
                  }}</span
                >
                <span
                  *ngIf="solicitudForm.get('apellidos')?.errors?.['pattern']"
                  class="text-danger"
                  >{{
                    'crear-solicitud.apellidos-validacion' | translate
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="entidadId != Constants.ID_ENTIDAD_SIC">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="tipoDocId"
                  class="form-label text3-tipografia-govco mb-0"
                >{{"comun-label.tipo-documento" | translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <select
                formControlName="tipoDocId"
                class="form-select ms-1"
                type="text"
                id="tipoDocId"
                (change)="validarTiposDocumento()"
                [ngClass]="{
                  'is-valid':
                    solicitudForm.get('tipoDocId')?.valid &&
                    solicitudForm.get('tipoDocId')?.touched,
                  'is-invalid':
                    solicitudForm.get('tipoDocId')?.invalid &&
                    solicitudForm.get('tipoDocId')?.touched,
                }">
                <option value disabled>{{"tramites.seleccione-opcion" | translate}}</option>
                <option *ngFor="let item of tiposDocumento" [value]="item.Id">
                  {{ item.Descripcion }}
                </option>
              </select>
              <div
                *ngIf="
                  solicitudForm.get('tipoDocId')?.invalid &&
                  (solicitudForm.get('tipoDocId')?.dirty ||
                    solicitudForm.get('tipoDocId')?.touched)
                ">
                <span
                  *ngIf="
                    solicitudForm.get('tipoDocId')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"registry.tipo_documento_required" | translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="cedula"
                  class="form-label text3-tipografia-govco mb-0"
                >{{"registry.numero_documento" | translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="cedula"
                formControlName="cedula"
                placeholder="Ingrese el número de documento"
                appTipoDocumentoValidation
                [ngClass]="{
                  'is-valid':
                    solicitudForm.get('cedula')?.valid &&
                    solicitudForm.get('cedula')?.touched,
                  'is-invalid':
                    solicitudForm.get('cedula')?.invalid &&
                    solicitudForm.get('cedula')?.touched,
                }" />
              <div
                *ngIf="
                  solicitudForm.get('cedula')?.invalid &&
                  (solicitudForm.get('cedula')?.dirty ||
                    solicitudForm.get('cedula')?.touched)
                ">
                <span
                  *ngIf="
                    solicitudForm.get('cedula')?.errors?.[
                      'required'
                    ]
                  "
                  class="text-danger">
                  {{"registry.numero_documento_required" | translate}}
                </span>
                <div *ngIf="solicitudForm.get('tipoDocId')?.value == 1 ||
                  solicitudForm.get('tipoDocId')?.value == 2 ||
                  solicitudForm.get('tipoDocId')?.value == 5">
                    <span
                    *ngIf="
                      solicitudForm.get('cedula')?.errors?.[
                        'maxlength'
                      ]
                    "
                    class="text-danger">
                    {{"comun-label.numero-documento-maxlength" | translate}}
                  </span>
                  <span
                    *ngIf="
                      solicitudForm.get('cedula')?.errors?.[
                        'minlength'
                      ]
                    "
                    class="text-danger">
                    {{"comun-label.numero-documento-minlength" | translate}}
                  </span>
                </div>
                <div *ngIf="solicitudForm.get('tipoDocId')?.value == 4">
                  <span
                    *ngIf="
                      solicitudForm.get('cedula')?.errors?.[
                        'maxlength'
                      ]
                    "
                    class="text-danger">
                    {{"comun-label.numero-documento-maxlength-ce" | translate}}
                  </span>
                </div>
                <div *ngIf="solicitudForm.get('tipoDocId')?.value == 3">
                  <span
                    *ngIf="
                      solicitudForm.get('cedula')?.errors?.[
                        'maxlength'
                      ]
                    "
                    class="text-danger">
                    {{"comun-label.nit-maxlength" | translate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3" *ngIf="entidadId != Constants.ID_ENTIDAD_SIC">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label for="correo"
                  >{{ 'crear-solicitud.correo' | translate }} </label
                ><span class="text-danger"> *</span>
              </div>
              <input
                type="email"
                class="form-control"
                id="correo"
                maxlength="{{ maxLengthCorreo }}"
                (input)="validateInputLength($event, maxLengthCorreo)"
                formControlName="correo"
                placeholder="correo@mail.com"
                (blur)="transformToUppercase('correo')"/>
              <div
                *ngIf="
                  solicitudForm.get('correo')?.invalid &&
                  (solicitudForm.get('correo')?.dirty ||
                    solicitudForm.get('correo')?.touched)
                ">
                <span
                  *ngIf="solicitudForm.get('correo')?.errors?.['required']"
                  class="text-danger"
                  >{{ 'crear-solicitud.correo-obligatorio' | translate }}</span
                >
                <span
                  *ngIf="solicitudForm.get('correo')?.errors?.['email']"
                  class="text-danger"
                  >{{ 'crear-solicitud.correo-validacion' | translate }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row" id="archivos">
          <app-carga-archivos
            [entidadId]="entidadId"
            [tamanoMaxArchivo]="pesoMaxArchivosSIC"
            (filesEmit)="setFilesFormValue($event)"></app-carga-archivos>
        </div>
        <div *ngIf="mostrarTerminos && entidadId == Constants.ID_ENTIDAD_SIC" class="mt-3">
          <div class="p-3 border rounded bg-light">
            <h5 class="modal-title h5-tipografia-govco" id="modalDocumentosLabel">
              {{ 'crear-solicitud.titulo_firma' | translate }}
            </h5>
            <textarea
              class="form-control mt-2"
              rows="8"
              readonly
              style="white-space: pre-wrap;"
              [value]="terminosTexto">
            </textarea>

            <div class="mt-3 d-flex justify-content-end">
              <button type="button" class="btn-govco outline-btn-govco" (click)="aceptarTerminos()"
              aria-label="Aceptar términos">
                {{ 'crear-solicitud.si-acepto' | translate }}
              </button>

              <button type="button" class="btn-govco" (click)="rechazarTerminos()"
              aria-label="No aceptar términos">
                {{ 'crear-solicitud.no-acepto' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div
          class="row justify-content-xl-end justify-content-center mt-3"
          id="boton-envio">
          <div class="col-12 col-xl-3">
            <button
              type="button"
              (click)="onSubmit()"
              [disabled]="solicitudForm.invalid"
              class="btn-govco fill-send-govco"
              aria-label="Enviar solicitud">
              {{ 'crear-solicitud.enviar' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
